import type { AxiosResponse } from 'axios'
import { InitService } from './init.service'
import type Obra from './model/obra'
import type ObraDetalhes from './model/obra-detalhes'
import type ObraHistorico from './model/obra-historico'
import Filtros from './model/filtros'
import configService from '@/services/config.service'
import ufService from '@/services/uf.service'
import municipioService from '@/services/municipio.service'
import type Item from './model/item'

export class ObrasService extends InitService {
  async pesquisarObras(filtros: Filtros): Promise<AxiosResponse<Array<Obra>>> {
    return await this.post('Obras/PesquisarObras/', filtros)
  }

  async pesquisarObrasFiltroPadrao(): Promise<AxiosResponse<Array<Obra>>> {
    const responseUfs = await ufService.obterUfs()
    const ufs = responseUfs.data

    const responseFiltroPadrao = await configService.carregarFiltroPadrao()
    const filtroPadrao = responseFiltroPadrao.data

    const filtros = new Filtros()
    const uf = ufs.find((uf) => uf.descricao == filtroPadrao.estado)
    if (uf != null) {
      filtros.uf = uf

      const responseMunicipios = await municipioService.obterMunicipios(uf.id)
      const municipios = responseMunicipios.data
      const municipio = municipios.find(
        (municipio) => municipio.descricao == filtroPadrao.municipio
      )
      if (municipio != null) {
        filtros.municipios = [municipio]
        }

      const existeStatusContratado = filtroPadrao.loteStatus.some(
            (status: Item) => status.descricao == 'Contratado'
        );

      if (existeStatusContratado) 
        filtros.situacoesLote = [{ id: 6, descricao: 'Contratado' }];
    }

    return await obrasService.pesquisarObras(filtros)
  }

  async obterLote(codigoLote: number): Promise<AxiosResponse<Obra>> {
    return await this.get(`Obras/ObterLote/${codigoLote}`)
  }

  async obterDetalhesObra(
    codigoLote: number,
    codigoContrato: number
  ): Promise<AxiosResponse<ObraDetalhes>> {
    return await this.get(`Obras/ObterDetalhesObra/${codigoLote}/${codigoContrato}`)
  }

  async obterHistoricoObra(codigoLote: number): Promise<AxiosResponse<Array<ObraHistorico>>> {
    return await this.get(`Obras/ObterHistoricoObra/${codigoLote}`)
  }

  async obterTemMedicaoConfirmada(codigoLote: number, codigoProjeto: number): Promise<AxiosResponse<boolean>> {
    return await this.get(`Obras/TemMedicaoConfirmada/${codigoLote}/${codigoProjeto}`)
  }

  async obterBoletimMedicao(codigoLote: number, codigoProjeto: number): Promise<AxiosResponse<Blob>> {
    return await this.get(`Obras/ObterBoletimMedicao/${codigoLote}/${codigoProjeto}`, false, {
      responseType: 'blob'
    })
  }

  async obterOrcamentoContratadoOriginal(codigoLote: number, codigoProjeto: number): Promise<AxiosResponse<Blob>> {
    return await this.get(`Obras/ObterOrcamentoContratadoOriginal/${codigoLote}/${codigoProjeto}`, false, {
      responseType: 'blob'
    })
  }

  async obterDetalhesExecucao(codigoLote: number, codigoProjeto: number): Promise<AxiosResponse<Blob>> {
    return await this.get(`Obras/ObterDetalhesExecucao/${codigoLote}/${codigoProjeto}`, false, {
      responseType: 'blob'
    })
  }
}

const obrasService = new ObrasService()
export default obrasService
